import { Button, Fab, Grid, InputLabel, Popover } from "@mui/material";
import React from "react";
import { SketchPicker, SketchPickerProps } from "react-color";
import { useTranslation } from "react-i18next";

type Props = {
  label?: string;
  noContainer?: boolean;
  square?: boolean;
} & SketchPickerProps;

const SingleColorPicker = ({
  label,
  noContainer,
  square,
  ...sketchPickerProps
}: Props): JSX.Element => {
  const { t } = useTranslation("cesium");
  const { color } = sketchPickerProps;

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement>();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(undefined);
  };
  if (square)
    return (
      <>
        <Button
          onClick={handleClick}
          sx={{
            height: 20,
            width: 64,
            backgroundColor: color?.toString(),
            "&:hover": {
              backgroundColor: color?.toString(),
            },
            borderRadius: 0,
            m: "0 auto",
          }}
        />
        <Popover
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={handleClose}
          onAuxClick={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <SketchPicker disableAlpha {...sketchPickerProps} />
        </Popover>
      </>
    );

  return (
    <Grid
      container={!noContainer}
      direction={!noContainer ? "column" : undefined}
      style={{ height: "100%", justifyContent: "center" }}
    >
      <InputLabel shrink>{label ?? t("point-color")}</InputLabel>
      <Fab
        onClick={handleClick}
        style={{
          backgroundColor: color?.toString(),
          height: 24,
          width: 24,
          minHeight: 24,
        }}
      >
        <></>
      </Fab>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        onAuxClick={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <SketchPicker disableAlpha {...sketchPickerProps} />
      </Popover>
    </Grid>
  );
};

export default SingleColorPicker;
